import { SearchDomain } from '../enum/search.domain';

export class UserSearch {
  constructor(
    public query: string,
    public where: SearchDomain = SearchDomain.ALL
  ) { }
}
